import { useEffect, useState } from "react"

import EventEmitter from "src/EventEmitter"
import cable from "src/cable"

const useWebsocket = ({ channelName, channelProps }) => {
  const [channel, setChannel] = useState(null)

  useEffect(() => {
    if (!channelProps) return

    const subscription = cable.subscriptions.create(
      {
        channel: channelName,
        ...channelProps,
      },
      {
        received: data => {
          EventEmitter.dispatch(data.action, data)
        },
        error: e => {
          logger.error("channel error", e)
        },
      }
    )

    setChannel(subscription)

    return () => {
      subscription.unsubscribe()
      setChannel(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelName, channelProps?.id])

  return { channel }
}

export default useWebsocket
